module.exports = __webpack_public_path__ + "static/media/lines-sc.f4c2aa84.svg";